import type React from "react";
// ????? ===================== REUSABLE TAB COMPONENT =================== ?????? //
// ????? ===================== REUSABLE TAB COMPONENT =================== ?????? //

import { useState } from "react";
import style from "./Tabs.module.scss";

type TabsType = {
    tabs: {
        label: string;
        onClick: () => void;
        content: React.ReactNode | React.JSX.Element;
    }[];
};

export const TabComponent = ({ tabs }: TabsType) => {
    const [activeTab, setActiveTab] = useState(0);

    const handleTabClick = (index: number) => {
        setActiveTab(index);
    };

    return (
        <div className={style.glassBox}>
            <div className={style.tabList}>
                {tabs.map((tab, index) => (
                    <button
                        key={index}
                        onClick={() => {
                            handleTabClick(index);
                            tab.onClick();
                        }}
                        className={`${style.tabListButton} ${
                            index === activeTab ? style.activeTab : ""
                        }`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
            <div className="tab-content">{tabs[activeTab].content}</div>
        </div>
    );
};